<template>
  <div class="feedBack">
    <textarea v-model.trim="value" placeholder="请描述您遇到的问题或想反馈的意见"></textarea>
    <van-button @click="save" round size="large" type="info">提交</van-button>
    <!-- <Back /> -->
  </div>
</template>

<script>
import {saveFeedback} from '@/api'
export default {
  data() {
    return {
      value: ''
    }
  },
  methods: {
    save() {
      if (!this.value) {
        this.$Toast.fail('意见不能为空')
        return false
      }
      saveFeedback(this.value).then(res => {
        if (res.code === 0) {
          this.$Toast.success('保存成功')
          this.value = ''
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.feedBack {
  padding: 12px 16px;
  textarea {
    resize: none;
    width: 100%;
    border: none;
    border-radius: 8px;
    padding: 10px;
    height: 140px;
    background: #ffffff;
    box-shadow: 0px 0px 12px 0px rgba(23, 38, 71, 0.08);
    margin-bottom: 20px;
  }
}
</style>
